import { NetworkAttackView } from '../view/NetworkAttackView';
import { templateNetworkAttack } from '../view/template';
import { BaseWidgetController } from '../../widget/BaseWidgetController';
import { NetworkAttackWebComponent } from '../component/NetworkAttackWebComponent';
import { GetBlockedNetworkAttackTechniquesResponse } from '@nirvana/shared/dtos/types/widgets/common';

export class NetworkAttackController extends BaseWidgetController<GetBlockedNetworkAttackTechniquesResponse> {
  public component: NetworkAttackWebComponent;
  public view: NetworkAttackView;
  public viewConstructor: typeof NetworkAttackView;

  constructor(component: NetworkAttackWebComponent) {
    super(component);
    this.initialWidgetSetup({
      viewConstructor: NetworkAttackView,
      viewTemplate: templateNetworkAttack,
      dataFetchMethod: this.component.dependencies.api.clients.Widgets.getBlockedNetworkAttackTechniques,
    });
  }
}
